import React, { useState } from "react";
import {
  AlertCircle,
  CheckCircle2,
  Clock,
  DollarSign,
  MapPin,
  PhoneOff,
  Users,
  BarChart
} from "lucide-react";
import CarrierSignupForm from "./CarrierSignupForm";
import "./Carriers.css";

const Carriers = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openCarrierForm = () => setIsFormOpen(true);

  return (
    <div className="carriers-page">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-tag">Carriers</p>
            <h1>
              Get Paid Fast. <span>Get Loaded Faster.</span>
            </h1>
            <p className="subhead">
              No games, no runaround. We pay within 24 hours, our lanes are consistent,
              and when you call us, a real person answers. That's it.
            </p>
            <div className="hero-cta">
              <button
                type="button"
                className="btn btn-primary btn-large"
                onClick={openCarrierForm}
              >
                Sign Up Now →
              </button>
              <a className="btn btn-outline-white btn-large" href="tel:+13175370657">
                Call Us Direct
              </a>
            </div>
          </div>
          <div className="hero-card">
            <div className="hero-card-header">
              <div className="hero-card-icon">
                <DollarSign />
              </div>
              <div>
                <h3>Get Paid Your Way</h3>
                <p>Flexible payment options</p>
              </div>
            </div>
            <div className="quick-pay-options">
              <div className="pay-option">
                <span className="pay-option-label">Quick Pay</span>
                <span className="pay-option-time">24 hours</span>
              </div>
              <div className="pay-option">
                <span className="pay-option-label">Standard Pay</span>
                <span className="pay-option-time">15 days</span>
              </div>
              <div className="pay-option">
                <span className="pay-option-label">Direct Deposit</span>
                <span className="pay-option-time">Available</span>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-primary btn-large"
              onClick={openCarrierForm}
            >
              Start Hauling →
            </button>
          </div>
        </div>
      </section>

      <section className="pain-section">
        <div className="pain-content">
          <div className="pain-header">
            <h2>We Know the Frustrations</h2>
            <p>You've dealt with brokers who don't pay, don't call back, and don't care. We're different.</p>
          </div>
          <div className="pain-grid">
            <div className="pain-card">
              <div className="pain-icon">
                <Clock />
              </div>
              <div>
                <h4>"I'm always chasing my money"</h4>
                <p>Quick Pay in 24 hours with POD. No excuses, no delays. Direct deposit every time.</p>
              </div>
            </div>
            <div className="pain-card">
              <div className="pain-icon">
                <PhoneOff />
              </div>
              <div>
                <h4>"Nobody ever answers"</h4>
                <p>Call our dispatch and a real person picks up. 24/7 support for active loads.</p>
              </div>
            </div>
            <div className="pain-card">
              <div className="pain-icon">
                <AlertCircle />
              </div>
              <div>
                <h4>"The rate was different at delivery"</h4>
                <p>No surprise deductions.</p>
              </div>
            </div>
            <div className="pain-card">
              <div className="pain-icon">
                <MapPin />
              </div>
              <div>
                <h4>"Appointments weren't correct"</h4>
                <p>We confirm appointments before sending load confirmations.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stats-content">
          <div className="stats-header">
            <h2>Let Sunny Logistics Work for You</h2>
            <p>
              Founded in 2019, we built our company on the principle of treating carriers with fairness and transparency.
              Our extensive customer base in the Midwest provides consistent freight opportunities year-round.
            </p>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">3,000+</div>
              <div className="stat-label">Loads Delivered</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">1:1</div>
              <div className="stat-label">Dedicated Dispatch</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Active Shippers</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24hr</div>
              <div className="stat-label">Quick Pay</div>
            </div>
          </div>
        </div>
      </section>

      <section className="partner-section">
        <div className="partner-content">
          <div className="partner-header">
            <h2>Why Carriers Partner With Us</h2>
          </div>
          <div className="partner-grid">
            <div className="partner-card">
              <DollarSign className="partner-card-icon" />
              <h3>Competitive Rates</h3>
              <p>
                Fair market rates with Quick Pay in 24 hours. No games.
                What we agree on is what you get.
              </p>
            </div>
            <div className="partner-card">
              <BarChart className="partner-card-icon" />
              <h3>Consistent Freight</h3>
              <p>
                Access steady, year-round opportunities from our established Midwest customer base.
                Plan your week, not just your day.
              </p>
            </div>
            <div className="partner-card">
              <Users className="partner-card-icon" />
              <h3>Dedicated Support</h3>
              <p>
                Work with a dedicated team that actually understands your business.
                One point of contact who knows your name.
              </p>
            </div>
          </div>
    </div>
      </section>

      <section className="network-section">
        <div className="network-content">
          <div className="network-text">
            <h2>Powered by Tech</h2>
            <p>
              Our carrier network runs on cutting-edge technology that makes your job easier—not harder.
              Book loads, submit documents, and track payments all from your phone.
            </p>
            <ul className="network-features">
              <li><CheckCircle2 /> Real-time load matching and booking</li>
              <li><CheckCircle2 /> Automated document processing</li>
              <li><CheckCircle2 /> Quick and easy settlement access</li>
              <li><CheckCircle2 /> Mobile app for on-the-go management</li>
            </ul>
          </div>
          <div className="network-card">
            <h3>Hot Lanes This Week</h3>
            <div className="lane-list">
              <div className="lane-item">
                <span className="lane-route">Indianapolis → Chicago</span>
                <span className="lane-status">Available</span>
              </div>
              <div className="lane-item">
                <span className="lane-route">Columbus → Detroit</span>
                <span className="lane-status">Available</span>
              </div>
              <div className="lane-item">
                <span className="lane-route">Louisville → Nashville</span>
                <span className="lane-status">Available</span>
              </div>
              <div className="lane-item">
                <span className="lane-route">Cincinnati → St. Louis</span>
                <span className="lane-status">Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="requirements-section">
        <div className="requirements-content">
          <div className="requirements-header">
            <h2>Partner Requirements</h2>
            <p>Here's what you need to haul with us. Simple and straightforward.</p>
          </div>
          <div className="requirements-grid">
            <div className="requirement-card">
              <h4>Insurance Coverage</h4>
              <ul className="requirement-list">
                <li><CheckCircle2 /> $100,000 Cargo Insurance</li>
                <li><CheckCircle2 /> $1,000,000 Auto Liability</li>
              </ul>
            </div>
            <div className="requirement-card">
              <h4>Compliance</h4>
              <ul className="requirement-list">
                <li><CheckCircle2 /> Valid Operating Authority</li>
                <li><CheckCircle2 /> Satisfactory Safety Rating</li>
                <li><CheckCircle2 /> ELD Compliance</li>
              </ul>
            </div>
            <div className="requirement-card">
              <h4>Documentation</h4>
              <ul className="requirement-list">
                <li><CheckCircle2 /> W-9 Form</li>
                <li><CheckCircle2 /> Carrier Agreement</li>
                <li><CheckCircle2 /> Direct Deposit Info</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="testimonial-content">
          <p className="testimonial-quote">
            "I've worked with a lot of brokers over 15 years. Sunny is one of the few that actually pays on time
            and treats you like a partner, not just a truck number. Their Midwest lanes keep me close to home."
          </p>
          <div className="testimonial-author">
            <div className="author-avatar">JR</div>
            <div className="author-info">
              <h4>James R.</h4>
              <p>Owner-Operator, 15 years experience</p>
            </div>
          </div>
    </div>
      </section>

      <section className="cta-section" id="signup">
        <div className="cta-card">
          <h2>Ready to Haul With Us?</h2>
          <p>Sign up takes 10 minutes. Start hauling this week.</p>
          <div className="cta-buttons">
            <button
              type="button"
              className="btn btn-primary btn-large"
              onClick={openCarrierForm}
            >
              Sign Up as a Carrier →
            </button>
            <a className="btn btn-outline-white btn-large" href="tel:+13175370657">
              Call (317) 537-0657
            </a>
          </div>
          <p className="cta-contact">
            Or email us at <a href="mailto:carriers@sunnylogistics.co">carriers@sunnylogistics.co</a>
          </p>
        </div>
      </section>

      <footer className="carriers-footer">
        <div className="footer-content">
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/shippers">Ship with us</a></li>
              <li><a href="/carriers">Register as a Carrier</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Our Office</h4>
            <address>
              11 MUNICIPAL DRIVE<br />
              SUITE 200<br />
              FISHERS, IN 46038
            </address>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Sunny Logistics. All rights reserved.</p>
        </div>
      </footer>

      <CarrierSignupForm open={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </div>
  );
};

export default Carriers;
